const microvision = {
    path: '/microvision',
    name: 'microvision',
    component: resolve => require(['@/views/micro-vision/micro-vision.vue'], resolve),
    children:[
      {
        path: 'index',//视频列表
        meta:{
          tabBar: false,
        },
        component: resolve => require(['@/views/micro-vision/index.vue'], resolve),
        children:[

        ]
      },
      {
        path: 'details',  // 微视视频详情
        meta:{
          tabBar: false,
        },
        component: resolve => require(['@/views/micro-vision/details.vue'], resolve), 
        children:[
  
        ]
      },
    ]
  };
  
  export default microvision;
  